import {Typography, Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import Divider from '@jobseeker/lotus/components/Divider';

const adImages = [
  'https://edgar.iimjobs.com/media/featuredinstitute/2023/03/14/2023-03-14-12-26-02-31083.jpg',
  'https://edgar.iimjobs.com/media/featuredinstitute/2023/02/14/2023-02-14-10-47-46-4830.png',
  'https://edgar.iimjobs.com/media/featuredinstitute/2023/03/14/2023-03-14-15-27-40-51280.jpg',
  'https://edgar.iimjobs.com/media/featuredinstitute/2023/03/02/2023-03-02-16-34-03-46532.png',
  'https://edgar.iimjobs.com/media/featuredinstitute/2023/02/13/2023-02-13-11-17-57-61910.png',
  'https://edgar.iimjobs.com/media/featuredinstitute/2021/11/22/2021-11-22-13-55-07-65762.jpg',
];

const FeaturedInstitute = () => {
  return (
    <Box sx={{mt: 5}}>
      <Typography
        component={'span'}
        fontSize={18}
        fontWeight={600}
        color="gray.dark"
      >
        Featured Institutes
      </Typography>
      <Divider
        sx={{
          margin: '10px 0 !important',
          border: '0.5px solid #ddd !important',
        }}
      />
      {adImages.map((imgSrc: string, i: number) => (
        <Box key={`adimages-${i}`}>
          <Box sx={{width: '100%', display: 'grid'}}>
            <Box sx={{width: '100%', height: '120px', position: 'relative'}}>
              <Image
                src={imgSrc}
                alt="MIT"
                fill
                quality={50}
                placeholder="blur"
                blurDataURL={imgSrc}
                objectFit="contain"
              />
            </Box>
          </Box>
          <Divider
            sx={{
              margin: '10px 0 !important',
              border: '0.5px solid #ddd !important',
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default FeaturedInstitute;
